import { render, staticRenderFns } from "./WDialog.vue?vue&type=template&id=4c94cc38&scoped=true&"
import script from "./WDialog.vue?vue&type=script&lang=js&"
export * from "./WDialog.vue?vue&type=script&lang=js&"
import style0 from "./WDialog.vue?vue&type=style&index=0&id=4c94cc38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c94cc38",
  null
  
)

export default component.exports